

define(['angular', 'squid/index', 'components/xo-device-info/dist/index', 'components/xo-beaver/dist/logger'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-login.directive.kmliEligibility', ['squid', 'xo-device-info', 'beaver']).factory('$KmliEligibility', function ($DeviceInfo, $window, $meta, $config, $pxp, $pxpMatch, $populate, $logger, $rootScope, $feature, $util, $q, $CheckoutAppDataModel, $CheckoutCartModel, $AuthModel) {
        var scope = {};
        scope.token = $rootScope.token;
        scope.eligibility = {};
        var ulMeta = $config.ulMeta || {};

        function getPXPList(country) {
            // returns a list of Pxp's that needs to be executed
            var countryCTX = { 'ctx.COUNTRY': country };
            var pxpExpId = ulMeta.pxpExpId;
            var pxpList = [$pxp(pxpExpId, countryCTX, 'xo_hermes_ul_timeout_treatment.*'), $pxp(pxpExpId, countryCTX, 'xo_hermes_ul_preload_treatment')];
            return pxpList;
        }

        function routingReason() {
            // Check for conditions that deviates from the PXP eligibility
            // Reasons that deviates from control to treatment
            var isRememberedUser = scope.auth.refreshToken();
            if (scope.kmli === true) {
                return 'kmliMandated';
            } else if (isRememberedUser) {
                return 'rememberedUser';
            } else if ($util.param('ul') === '2') {
                return 'ulParam';
            } else if ($meta.corp && ulMeta.allowKMLIForInternalIP) {
                var merchantCountry = scope.checkoutAppData.merchant.merchant_country;
                if ($feature('enableOneTouchInternalIP', false, merchantCountry)) {
                    return 'internalIP';
                }
            } else if (ulMeta.enableOneTouchByDefault) {
                return 'oneTouchByDefault';
            }
        }

        function compatibility(reasons) {
            // Check for compatibility/environment issues which impacts UL/KMLI overall
            // This should override previous decisions
            if ($DeviceInfo.isApp()) {
                scope.kmliEligibility = false;
                reasons.push('Webview');
            } else if (!$util.cookiesEnabled()) {
                scope.kmliEligibility = false;
                reasons.push('cookiesDisabled');
            } else if (scope.auth.ota) {
                scope.kmliEligibility = false;
                reasons.push('otaDevice');
            }

            if (scope.forcedLogin === true) {
                scope.kmliEligibility = false;
                reasons.push('forcedLogin');
            }
            if (scope.logoutCallback) {
                scope.kmliEligibility = true;
                reasons.push('riskyLoginContingency');
            }
        }

        function isULpreload(preloadULTreatments) {
            // Allow all IE traffic irrespective of PXP
            var userAgent = $window.navigator.userAgent;
            var isIE = !!userAgent.match(/MSIE|trident|edge/i);
            // Check force param
            var forceUlss = $util.param('_ulss') === 'true';
            var preloadUL = Boolean(preloadULTreatments && preloadULTreatments.treatment_name) || isIE || forceUlss;

            return preloadUL;
        }

        function isUlAsLanding() {
            // markes
            var forceUlAsLanding = $util.param('ul') === 'landing';
            var ulAsLandingParam = $util.param('ulReturn') === 'true';

            // tried Ul as landing -> failed -> used iframe
            var failedAttempt = $util.param('lndgFailedBecause'); // eslint-disable-line no-unused-vars


            return forceUlAsLanding || ulAsLandingParam;
        }

        function getTimeoutLimit(pxpTimeoutTrt) {
            var ulTimeoutLimit;
            var timeoutTrtFact = pxpTimeoutTrt && angular.isArray(pxpTimeoutTrt.factors);
            var pxpTimeoutVal = timeoutTrtFact && pxpTimeoutTrt.factors[0] && pxpTimeoutTrt.factors[0].value;
            if (pxpTimeoutVal) {
                ulTimeoutLimit = pxpTimeoutVal;
                $logger.info('pxp_timeout_treatment', {
                    'ulTimeoutLimit': ulTimeoutLimit
                });
            }
            return ulTimeoutLimit;
        }

        return {
            init: function init(params) {
                if (Boolean(scope.eligibility.treatment)) {
                    // do not init twice
                    return $q.resolve(scope.eligibility);
                }
                $logger.debug('kmliEligibility_init');
                scope.forcedLogin = params && params.forcedLogin;
                scope.logoutCallback = params && params.logoutCallback;
                return $populate(scope, {
                    auth: $AuthModel.instance(),
                    checkoutAppData: $CheckoutAppDataModel.instance(scope.token),
                    checkoutCart: $CheckoutCartModel.instance(scope.token)
                }).then(function () {
                    var country = scope.checkoutAppData.merchant.merchant_country;
                    return $q.all(getPXPList(country)).then(function (result) {
                        scope.eligibility.ulTimeoutLimit = getTimeoutLimit(result[0]);
                        scope.eligibility.preloadUL = isULpreload(result[1]);
                        scope.eligibility.safeEligibility = true;
                        scope.eligibility.ulAsLanding = isUlAsLanding();
                    });
                }).then(function () {
                    // STEP1: kmli pxp ramped to 100%, so always kmli eligible
                    scope.kmliEligibility = true;

                    // STEP2: Push the eligible reasons from routingReason check.
                    var reasons = []; // Reasons that deviates from control to treatment
                    reasons.push('pxpFullyRamped');

                    var reason = routingReason();
                    if (reason) {
                        scope.kmliEligibility = true;
                        reasons.push(reason);
                    }

                    // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
                    compatibility(reasons);

                    var routing_reason = reasons[reasons.length - 1];

                    scope.eligibility.treatment = true;
                    scope.eligibility.routingReason = routing_reason;
                    scope.eligibility.deviatingReasons = reasons;
                    scope.eligibility.kmliEligibility = scope.kmliEligibility;

                    // STEP4: Instrument deterministically whether KMLI is shown to the user or not
                    $logger.debug(scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
                    $logger.info('checkout_fpti', {
                        'from': 'KMLI_ELG_CHK',
                        'to': 'process_kmli_elg_chk',
                        'routing_reason': routing_reason
                    });
                    return scope.eligibility;
                });
            },

            eligible: function eligible() {
                return scope.eligibility;
            }

        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/login/kmliEligibility.js
// module id = ./components/xo-login-components/src/login/kmliEligibility.js
// module chunks = 1